import React, { useState } from "react";
import { CopyIcon, InfoIcon, SortIcon } from "../utils/Icons";
import Divider from "./Divider";
import Float from "./Float";

const Alert = (props) => {

    const { type = "error", title = "", description = "", color = "var(--text-red)", textColor = undefined, dismissible = false, callback = () => { } } = props;
    const [visible, setVisible] = useState(true);

    if (!visible) return null;



    return (
        <div style={{"backgroundColor" : color, ...(textColor ? { "color": textColor } : {})}} className={`ui-alert ${type}` }>
            <div className="alert-content" >

                {(title || dismissible) &&
                    <Float>
                        <div><strong>{title}</strong></div>
                        <div>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {dismissible && (
                                <button className="alert-dismiss" onClick={() => callback(false)}>
                                    &times;
                                </button>
                            )}
                        </div>
                    </Float>
                }

                {(title || dismissible) && <Divider className="light" />}
                <div className="shim" />
                <div className="alert-description">{description}</div>
            </div>

        </div>
    );
};

export default Alert;
